import React, { useEffect, useRef, useState } from "react";
import "./Collage_dashboard.css";
import { Col, Row } from "react-bootstrap";
import Collage_dashboard_buckets from "./collage_dashboard_buckets/Collage_dashboard_buckets";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faCircleCheck,
  faCircleInfo,
} from "@fortawesome/free-solid-svg-icons";
import InfoBanner from "../../student_portal/dashboard_Content/infoBanner/InfoBanner";
import Receptionist_card from "../../../../common_components/common-cards/receptionist_card/Receptionist_card";

function Collage_dashboard() {
  
  const reptionistCardsData = [
    {
      name: "Priyank Sharma",
      subTitle: "Arriving Soon",
      id: "APP12546",
      email: "priyank2254@gmail.com",
      contact: "+91 7869875654",
      uploadedBy: "18/01/2026",
      uploadDate: "18/01/2026",
      documents: [
        { doc: "Travel Insurance", icon: faCircleCheck },
        { doc: "Motivation", icon: faCircleInfo },
        { doc: "Statement", icon: faCircleCheck },
        { doc: "CV", icon: faCircleInfo },
      ],
      note: "Prepare the intern's arrival",
      status: "Confirmed",
    },
    {
      name: "Rahul Verma",
      subTitle: "Arriving Soon",
      id: "APP12547",
      email: "rahul.verma@gmail.com",
      contact: "+91 9876543210",
      uploadedBy: "Admin Team",
      uploadDate: "20/01/2026",
      documents: [
        { doc: "Travel Insurance", icon: faCircleCheck },
        { doc: "Motivation", icon: faCircleInfo },
        { doc: "Statement", icon: faCircleInfo },
        { doc: "CV", icon: faCircleCheck },
      ],
      note: "Prepare the intern's arrival",
      status: "Pending",
    },
  ];

  const [openStatus, setOpenStatus] = useState(false);
  const courseRef = useRef(null);

  useEffect(() => {
    const handleClick = (e) => {
      if (courseRef.current && !courseRef.current.contains(e.target))
        setOpenStatus(false);
    };

    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  return (
    <>
      <section className="Collage_dashboard application_section">
        <div>
          <div className="mb-3">
            <Collage_dashboard_buckets />
          </div>

          <div className="mb-3">
            <div className="heading_btn_holder">
              <div className="heading_text_holder">
                <h1>Student Applications</h1>
              </div>
              <div className="btn_holder">
                {/* SECOND DROPDOWN */}
                <div className="dropdown_wrapper">
  <button
    className="dark_btn"
    onClick={() => setOpenStatus(!openStatus)}
  >
    Filter
    <div className="aap_icon_holder">
      <FontAwesomeIcon
        icon={faChevronDown}
        className={`dropdown_icon ${openStatus ? "rotate" : ""}`}
      />
    </div>
  </button>

  {openStatus && (
    <div className="custom_dropdown">
      <button
        className="dropdown_item"
        onClick={() => setOpenStatus(false)}
      >
        Active
      </button>

      <button
        className="dropdown_item"
        onClick={() => setOpenStatus(false)}
      >
        Pending
      </button>
    </div>
  )}
</div>

              </div>
            </div>
          </div>

          <div className="mb-3">
            <div className="row g-3">
              {reptionistCardsData.map((item, index) => (
                <div
                  className=" col-xl-4 col-lg-6 col-md-6 col-sm-12 "
                  key={index}
                >
                  <Receptionist_card
                    name={item.name}
                    subTitle={item.subTitle}
                    id={item.id}
                    email={item.email}
                    contact={item.contact}
                    uploadedBy={item.uploadedBy}
                    uploadDate={item.uploadDate}
                    documents={item.documents}
                    note={item.note}
                    status={item.status}
                  />
                </div>
              ))}
            </div>
          </div>

          <div className="mb-3">
            <InfoBanner />
          </div>
        </div>
      </section>
    </>
  );
}

export default Collage_dashboard;
